export abstract class DasqlNode {
  private static readonly BACKSLASH_MATCHING_REGEX = /[\\]/g;
  private static readonly SINGLE_QUOTE_MATCHING_REGEX = /[']/g;

  private static readonly ESCAPED_SINGLE_QUOTE: string = `\\'`;
  private static readonly ESCAPED_BACKSLASH: string = `\\\\`;

  public abstract emit(): string;

  protected escapeSingleQuotes(query: string): string {
    return query
      .replace(DasqlNode.BACKSLASH_MATCHING_REGEX, DasqlNode.ESCAPED_BACKSLASH)
      .replace(DasqlNode.SINGLE_QUOTE_MATCHING_REGEX, DasqlNode.ESCAPED_SINGLE_QUOTE);
  }
}
